import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerAction} from '../../../../../libs/shared/ui/src/components/banners/bannerAction';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerFooterActions} from '../../../../../libs/shared/ui/src/components/banners/bannerFooterActions';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface NotificationsPermissionBannerProps {
  onDismissClick: () => void;
  onEnableClick: () => void;
}

/*
 * Component.
 */

export const NotificationsPermissionBanner: FC<NotificationsPermissionBannerProps> = (props) => {
  const theme = useUserTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.blue.shade40}
      priority={BannerPrioritiesEnum.INFORMATION}
    >
      <BannerCloseAction onClick={props.onDismissClick} />
      <BannerIcon iconName="bellSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="banner-notifications-title">Enable notifications</Trans>
        </BannerContentTitle>
        <Trans id="banner-notifications-message">
          Get instant alerts for new emails and important updates.
        </Trans>
      </BannerContent>
      <BannerFooterActions>
        <BannerAction onClick={props.onEnableClick}>
          <Trans id="banner-notifications-cta">Enable</Trans>
        </BannerAction>
      </BannerFooterActions>
    </Banner>
  );
};
